var map = {
	"./en/index": 1402
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3243;



//////////////////
// WEBPACK FOOTER
// ./~/sentiment/languages ^\.\/.*\/index$
// module id = 3243
// module chunks = 0